module.exports = __webpack_public_path__ + "img/avatar-1.5b4e5347.jpg";